import { forwardRef } from "react";

const ChevronUpIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.76876 5.68753C10.0771 5.37923 10.0771 4.87935 9.76876 4.57108L5.55822 0.360539C5.24991 0.0522227 4.75012 0.0522227 4.4418 0.360539L0.23123 4.57108C-0.0770765 4.87935 -0.0770765 5.37923 0.23123 5.68753C0.539536 5.99584 1.03941 5.99584 1.34772 5.68753L5.00001 2.03528L8.65234 5.68753C8.96066 5.99584 9.46045 5.99584 9.76876 5.68753Z"
        fill={props.fill || "#6C757D"}
      />
    </svg>
  ),
);

ChevronUpIcon.displayName = "ChevronUpIcon";

export default ChevronUpIcon;
